import { Link } from '@vimeo/iris/typography';

import footerLinks from '../../link';
import Accordion from '../Accordion';
import styles from './MobileFooter.module.scss';

const MobileFooter = ({ className, Logo }) => {
  return (
    <div className={className}>
      <div>{Logo}</div>
      {footerLinks.map((el, index) => (
        <div key={index}>
          <Accordion heading={el.category}>
            <div className={styles.links}>
              {el.links.map((link) => (
                <Link
                  variant="minimal"
                  href={link.href}
                  data-gtm-click={link.gtm}
                  data-fatal-attraction={link.fa}
                  key={link.text}
                  className={styles.footerLink}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </Accordion>
        </div>
      ))}
    </div>
  );
};

export default MobileFooter;
